<script setup lang="ts">
import { computed } from "vue";
import { storeToRefs } from "pinia";
import { Columns2, RectangleHorizontal } from "lucide-vue-next";
import { Tooltip } from "@/components/ui/tooltip";
import { useResultsV2Store } from "@stores/survey/resultsV2/resultsV2";
import { useResultsV2CardsStore } from "@stores/survey/resultsV2/resultsV2.cards";
import { useCurrentUserStore } from "@/stores/currentUser";
import { isHalfWidthCard } from "../constants";

interface SizableCard {
  id: number;
  card_type?: string;
  content?: { sub_type?: string };
  options?: { width?: string } | null;
}

const props = withDefaults(
  defineProps<{
    card: SizableCard;
    readonly?: boolean;
  }>(),
  { readonly: false },
);

const store = useResultsV2Store();
const cardsStore = useResultsV2CardsStore();
const { canWriteSurveys } = storeToRefs(useCurrentUserStore());

const visible = computed(() => props.readonly && canWriteSurveys.value);
const isHalf = computed(() => isHalfWidthCard(props.card, store.viewLayout));

function toggle() {
  cardsStore.setCardWidth(props.card.id, isHalf.value ? "full" : "half");
}
</script>

<template>
  <Tooltip v-if="visible" :content="isHalf ? 'Full width' : 'Half width'" :delay-duration="1000">
    <button
      aria-label="Toggle card width"
      class="inline-flex items-center justify-center rounded p-1 text-muted-foreground transition-colors hover:text-foreground"
      @click.stop="toggle">
      <RectangleHorizontal v-if="isHalf" class="h-3.5 w-3.5" />
      <Columns2 v-else class="h-3.5 w-3.5" />
    </button>
  </Tooltip>
</template>
